//Arabic
export const locale = {
	lang: 'ar',
	data: {
		TRANSLATOR: {
			SELECT: '',
		},
		MENU: {
			CSAT:'C-Sat',
			PRODUCTIVITY:'Productivity Report',
			LEADERBOARD:'LeaderBoard',
			REIM:'Reimbursement',
			TRAININGSCORE:'Training Score',
			TRANSFERSPARE:'Spare Transfer Request',
			IMPRESTSPARE:'Imprest Spare Request',
			NEW: '',
			ACTIONS: '',
			CREATE_POST: '',
			PAGES: '',
			FEATURES: '',
			APPS: '',
			DASHBOARD: 'لوحة القيادة',
			NEW_SUBSCRIPTION:'اشتراك جديد',
			MANAGE_SUBSCRIPTION:'إدارة الالتحاق',
			PRODUCT_MASTER:'سيد المنتج',
			KNOWLEDGE:'قائم على المعرفة',
			SLA_MAPPING:'جيش تحرير السودان الخرائط',
			BILLING_DETAILS:'تفاصيل الفاتورة',
			PACKAGE_TYPE:'نوع الحزمة',
			PACKAGE_PLAN:'خطة الحزمة',
			PACKAGE_MANAGEMENT:'إدارة الحزمة',
			PACKAGE_CONFIGURATION:'حزمة التكوين',
			WAREHOUSE:'سيد المستودع',
			SPARE:'سيد الغيار',
			SERVICE:'مجموعة الخدمات',
			AMC:'إدارة نوع AMC',
			SITE:'إعدادات الموقع',
			SMTP:'إعدادات SMTP',
			ORG_STR:'الهيكل التنظيمي',
			SMS:'إعدادات SMS',
			CUSTOMERMANAGEMENT:'ادارة الزبائن',
			CONTENT:'ادارة المحتوى',
			USER:'إدارةالمستخدم',
			PERFORMANCEMATRIX:'Performace Matrix',
			COMPLETEDTKT:'Completed Tickets',
		},
		AUTH: {
			GENERAL: {
				OR: '',
				SUBMIT_BUTTON: '',
				NO_ACCOUNT: '',
				SIGNUP_BUTTON: '',
				FORGOT_BUTTON: '',
				BACK_BUTTON: '',
				PRIVACY: '',
				LEGAL: '',
				CONTACT: '',
			},
			LOGIN: {
				TITLE: '',
				BUTTON: '',
			},
			FORGOT: {
				TITLE:'هل نسيت كلمة المرور ؟',
				DESC: ' ',
				SUCCESS: '.'
			},
			REGISTER: {
				TITLE: '',
				DESC: '',
				SUCCESS: ''
			},
			INPUT: {
				EMAIL: '',
				FULLNAME: '',
				PASSWORD: '',
				CONFIRM_PASSWORD: '',
				USERNAME: ''
			},
			VALIDATION: {
				INVALID: '{{name}} is not valid',
				REQUIRED: '{{name}} is required',
				MIN_LENGTH: '{{name}} minimum length is {{min}}',
				AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
				NOT_FOUND: 'The requested {{name}} is not found',
				INVALID_LOGIN: 'The login detail is incorrect',
				REQUIRED_FIELD: 'Required field',
				VALID_ADDRESS:'لو سمحت أدخل بريد إليكتروني صال',
				MIN_LENGTH_FIELD: 'Minimum field length:',
				MAX_LENGTH_FIELD: 'Maximum field length:',
				INVALID_FIELD: 'Field is not valid',
			}
		},
		ECOMMERCE: {
			COMMON: {
				SELECTED_RECORDS_COUNT: 'Selected records count: ',
				ALL: 'All',
				SUSPENDED: 'Suspended',
				ACTIVE: 'Active',
				FILTER: 'Filter',
				BY_STATUS: 'by Status',
				BY_TYPE: 'by Type',
				BUSINESS: 'Business',
				INDIVIDUAL: 'Individual',
				SEARCH: 'Search',
				IN_ALL_FIELDS: 'in all fields'
			},
			ECOMMERCE: 'eCommerce',
			CUSTOMERS: {
				CUSTOMERS: '顾客',
				CUSTOMERS_LIST: '客户名单',
				NEW_CUSTOMER: 'New Customer',
				DELETE_CUSTOMER_SIMPLE: {
					TITLE: 'Customer Delete',
					DESCRIPTION: 'Are you sure to permanently delete this customer?',
					WAIT_DESCRIPTION: 'Customer is deleting...',
					MESSAGE: 'Customer has been deleted'
				},
				DELETE_CUSTOMER_MULTY: {
					TITLE: 'Customers Delete',
					DESCRIPTION: 'Are you sure to permanently delete selected customers?',
					WAIT_DESCRIPTION: 'Customers are deleting...',
					MESSAGE: 'Selected customers have been deleted'
				},
				UPDATE_STATUS: {
					TITLE: 'Status has been updated for selected customers',
					MESSAGE: 'Selected customers status have successfully been updated'
				},
				EDIT: {
					UPDATE_MESSAGE: 'Customer has been updated',
					ADD_MESSAGE: 'Customer has been created'
				}
			}
		},
		PRODUCT_MASTER:{
			PARA:'الغسالة عبارة عن آلة تغسل الملابس القذرة .... هذا البرميل ممتلئ بالماء ، ثم يدور بسرعة كبيرة لجعل الماء يزيل الأوساخ من الملابس. تصنع معظم الغسالات بحيث يمكن وضع المنظفات (السوائل أو المساحيق) في الجهاز. هذه يمكن أن تساعد في جعل الملابس أنظف.',
			
             },
             NEW_SUBSCRIPTION:{
				 AIFO:'تفاصيل العنوان',
				TOTPRICE:'السعر الكلي',
				 MANAGE:'إدارة الاشتراك',
				 CREATE:'إنشاء اشتراك ',
				 SERIAL_NO:'الرقم التسلسلي',
				 ORG:'اسم المنظمة',
				 CONTACT:'اسم شخص الاتصال',
				 CONTACT_NO:'رقم الاتصال',
				 ORG_TYPE:'نوع المنظمة',
				 CANCEL:'إلغاء',
				 TOT_LICENSE:'مجموع رقم الترخيص',
				 USED_lICENSE:'رقم الترخيص المستخدم',
				 ACTION:'عمل',
				 RENEW:'جدد',
		EXTENT_DURATION:'تمديد المدة',
		MORE:'اشتري اكثر',
		REMOVE:'إزالة الترخيص',
		ACTIVE:'نشيط',
		BLOCK:'مسدود',
		ADD_NEW:'إضافة اشتراك جديد',
		                COMPANY_INFO:'معلومات الشركة',
                ADDRESS:'عنوان',
				CONFIRM_DETAILS:'تأكيد التفاصيل',
				PACKAGE_TYPE:'نوع الحزمة',
				PACKAGE_PLAN:'خطة الحزمة',
				PACKAGE_DETAILS:'حزمة من التفاصيل',
                ENTER:'أدخل تفاصيل الشركة',
                ADD:'عنوان',
				DET:'تأكيد التفاصيل',
				ORGNAME:'اسم المنظمة',
                NAME:'اسم الشركة',
                LOGO:'تحميل الشعا',
				LICENCE:'رقم الترخيص',
				USELICENSE:'عدد الرخص المستخدمة',
                CONNAME:'اسم جهة الاتصال',
                CONNUMBER:'رقم الاتصال',
                CONALTNUMBER:'عدد البديل',
                EMAIL:'البريد الإلكتروني',
                SUBPACK:'حزمة الاشتراك',
                SUBPLAN:'خطة الاشتراك',
                PACKAMT:'كمية الحزم',
                DOPLO:'القطعة رق',
                STR:'شارع',
                TOWN:'مدينة',
                LAND:'معلم معروف',
                CITY:'مدينة',
                COUNTRY:'بلد',
                STATE:'حالة',
                POSCODE:'الرمز البريدي',
				AMT:'كمية',
				DISCOUNTPERCENT:'نسبة الخصم',
				CALCULATE:'احسب',
				DISCOUNTAMT:'مقدار الخصم',
				NEW_PER_LICENSECOST:'تكلفة جديدة لكل ترخيص',
TOT_PRICE:'السعر الكلي',
                REQ:'مطلوب',
                DIGI:'يجب أن يكون 10 أرقام',
                VALID:'الرجاء إدخال صالح',
                SELECT:'تحديد',
                SHO:'يجب أن يكون في أرقام',
                FRTR:'تجربة مجانية',
                GOLD:'ذهب',
                SILVER:'فضة',
                PLATINUM:'بلاتين',
                MUST:'يجب أن يكون في 6 أرقام',
                NEXT_STEP:'الخطوة التالية',
                PREVIOUS:'سابق',
                SUB:'خضع',
				OK:'حسنا',
				STATUS:'الحالة',
				END_DATE:'تاريخ الانتهاء',
				THISFIELD:'هذا الحقل',
				DISCOUNT_PRICE:' سعر الخصم',
EXTEND_DAYS:'الأيام التي يجب تمديدها',
NEW_NOLICENSE:'رقم الترخيص الجديد',
REMOVELICENE:'لا إزالة الترخيص',
				VIEW_SUBSCRPTION:'عرض الاشتراك',
				EDIT_SUBSCRIPTION:' تحرير الاشتراك',
				RENEW_SUBSCRIPTION:'تجديد الاشتراك',
				REMOVE_SUBSCRIPTION:'إزالة الاشتراك',
				MANDATORY:'جميع الحقول إلزامية',
				MORE_SUBSCRIPTION:'شراء المزيد من الاشتراك',
				ADD_NOLICENSE:'رقم ترخيص الإضافة',
					},
					PACKAGE_PLAN:{
TITLE:'إنشاء خطة حزمة',
ADD_PACKAGE:'إضافة حزمة',
EDIT_PACKAGE:'تحرير الحزمة',
SERIAL_NO:'رقم سري',
PACKAGE_PLAN:'خطة حزمة',
RANGE:'نطاق',
LICENSE_COST:'تكلفة الترخيص',
NEWLICENSE_COST:'تكلفة الترخيص الجديد',
DISC_PERCENT:'نسبة الخصم',
DISC_AMT:'مقدار الخصم',
NEWCOST:'تكلفة جديدة',
ACTION:'عمل',
ACTIVE:'نشيط',
BLOCK:'مسدود',
FROM:'من عند',
TO:'إلى',
DISCOUNT_PRICE:'سعر الخصم',
TOT_PRICE:'السعر الكلي',
SUB:'خضع',
CANCEL:'إلغاء',
UPDATE:'تحديث',
STATUS:'الحالة',
PLAN:'خطة',
					},
					WAREHOUSE:{
						TITLE:'إدارة المستودع',
						NAME:' اسم المستودع',
						TIME:'المهلة (بالأيام)',
						SUB:'إرسال',
						ACTION:'عمل',
						SERIAL_NO:'الرقم التسلسلي',
						EDIT_WAREHOUSE:'تحرير مستودع',
						UPDATE:'تحديث',
								},
								
AMC:{
	TITLE:' نوع AMC',
	ADD_AMC:'أضف نوع AMC',
	AMC:'AMC',
	DURATION:'المدة الزمنية',
	COST:'كلفة',
	STATUS:'الحالة',
	ACTION:'عمل',
	SERIAL_NO:'الرقم التسلسلي',
	SUB:'إرسال',
	UPDATE:'تحديث',
	CANCEL:'إلغاء',
	EDIT_AMCDETAILS:'تحرير نوع AMC',
	AD_AMCREQUIRED:'مطلوب AMC',
	AD_AMCPATTERN:'السلاسل المسموح بها فقط',
	AD_AMCLIMIT:'يتجاوز الحد',
	AD_DURATIONREQUIRED:'المدة المطلوبة',
	AD_DURATIONPATTERNS:' الأرقام المسموح بها فقط',
	AD_DURATIONLIMITS:' مدة الحد تصل إلى 99 شهرا',
	AD_COSTRQUIRED:' مدة الحد تصل إلى 99 شهرا',
	AD_COSTPATTERN:'الأرقام المسموح بها فقط',
	ED_AMCREQUIRED:'مطلوب AMC',
	ED_AMCPATTERN:'السلاسل المسموح بها فقط',
	ED_AMCLIMIT:'يتجاوز الحد',
	ED_DURATIONREQUIRED:'المدة المطلوبة',
	ED_DURATIONPATTERNS:' الأرقام المسموح بها فقط',
	ED_DURATIONLIMITS:' مدة الحد تصل إلى 99 شهرا',
	ED_COSTRQUIRED:' مدة الحد تصل إلى 99 شهرا',
	ED_COSTPATTERN:'الأرقام المسموح بها فقط',
	ED_STATUSREQ:'الوضع مطلوب',
},
SERVICEGROUP:{
	TITLE:'إدارة مجموعة الخدمة',
	ADD_SERVICE:'إضافة خدمة المجموعة',
	ACTION:'عمل',
	WORK_TYPE:'نوع العمل',
	SERIAL_NO:'الرقم التسلسلي',
	SUB:'إرسال',
	WORKREQ:'مطلوب نوع العمل',
	WORKPATTERN:'لسلاسل المسموح بها فقط',
	WORKLIMIT:'  يتجاوز الحد',
	EDIT_SERVICE:'تحرير مجموعة الخدمات',
	UPDATE:'تحديث',
	CANCEL:'إلغاء',
	CHECK:'قائمة تدقيق',
	ADD_CHECK:'إضافة قائمة تحقق',
	DESC:'وصف',
	TYPE:'نوع',
	DATE:'تاريخ',
	EDIT_CHECK:'تحرير قائمة التحقق',

	
},
PRODUCTMASTER:{
	TITLE:'سيد المنتج',
	CATEGORY:'فئة المنتج',
	ADD_PROCAT:'إضافة فئة المنتج',
	BULKPRO:'تحميل مجمع',
	ADDSUB_PROCAT:'إضافة فئة المنتج الفرعي',
	PROCAT:'فئة المنتج',
	SUBPRO:'شبه المنتجات ',
	PRODESC:'وصف',
	PROMODALNO:'رقم الموديل',
	UPDATEPROCAT:'تحديث المنتج',
	UPDATESUBPROCAT:'تحديث المنتج الفرعي',
	CANCEL:'إلغاء',
UPDATE:'تحديث',
PRO:'المنتج',
	SUBPRONAME:'اسم المنتج الفرعي',
	IMAGE:'تحميل الصور',
	UPLOADPROLIST:'تحميل قائمة المنتجات',
	UPLOADSUBPROLIST:'تحميل المنتج الفرعي',
	SAMPLE:'نموذج القالب',
	SELECT:' اختر الملف',
	UPLOAD:'رفع',

},
SPAREMASTER:{
	TITLE:'إدارة قطع الغيار الرئيسية',
	ADD_SPARE:'سيد الغيار',
	UPLOAD_SPARELIST:'تحميل قائمة الغيار',
	BULK_SPARE:'تحميل مجمع',
	SERIAL_NO:'الرقم التسلسلي',
	WARE_LOCATION:'مستودع الموقع',
	SUB_PRO:'المنتج الفرعي',
	QUANTITY_PURCHASE:'الكمية المشتراة',
	QUANTITY_USED:'الكمية المستخدمة',
	SPARE_IMAGE:'صورة احتياطية',
	SPARE_CODE:'رمز الغيار',
	SPARE_NAME:'اسم الغيار',
	PURCHASE:'عملية الشراء',
	EXPIRE:'تنقضي',
	ACTION:'عمل',
	SUB:'إرسال',
	PRO:'المنتج',
	IMAGE:'صورة',	
	DESC:'وصف',
	DATE_PUR:' تاريخ الشراء',
	DATE_EXP:'تاريخ انتهاء الصلاحية',
	SAMPLE:'نموذج القالب',
	SELECT:' اختر الملف',
	UPLOAD:'رفع',
	CANCEL:'إلغاء',
	EDIT_SPARE:'تحرير قطع الغيار',
	AD_SPARENAMEREQUIRED:'اسم قطع الغيار مطلوب',
	AD_SPAREDESC:'الوصف مطلوب',
	AD_SPAREIMAGE:'الصورة الاحتياطية مطلوبة',
	AD_PRO:'المنتج مطلوب',
	AD_SUBPRO:'المنتج الفرعي مطلوب',
	AD_WARE:'مستودع مطلوب',
	AD_PURQUANTITY:'الكمية المشتراة مطلوبة ',
	AD_USEQUANTITY:' الكمية المستخدمة مطلوبة',
	AD_DATEPUR:'تاريخ الشراء مطلوب',
	AD_DATEEXP:'تاريخ انتهاء الصلاحية مطلوب',
	SPAREMODEL:'نموذج احتياطي',
	PRICE:'السعر',
	VIEW_SPARE: 'مشاهدة ملف',
	DIGI:'يجب أن يكون أكبر من واحد',
	MAX:'الطول الأقصى 45 حرفًا',

	


},
SITE:{
	TITLE:'إدارة إعدادات الموقع',
	ADD_SITE:'إضافة إعدادات الموقع',
	Edit_SITE:'تحرير إعدادات الموقع',
	SITE_ID:'معرف الموقع',
COPY:'معلومات حقوق النشر',
NOTIFY:'الإخطار انقضاء الوقت',
TECHRADIUS:'فني نصف القطر',
ACTION:'عمل',
SERIAL_NO:'الرقم التسلسلي',
SUB:'إرسال',
UPDATE:'تحديث',
COPYR:'حقوق الطبع والنشر المطلوبة',
NOTIFYE:'مطلوب وقت مرور الإخطار',
ELAPSED:'الوقت المنقضي هو الأرقام فق',
TECH:'مطلوب نصف القطر فني',
TECHNUM:'فني دائرة نصف قطرها هو الأرقام فقط',
},
SMTP:{
	TITLE:'إدارة إعدادات SMTP',
	ADD_SMTP:'أضف SMTP',
	EDIT_SMTP:'تحرير SMTP',
		HOSTNAME:'اسم المضيف',
	USER:'اسم المستخدم',
	PASS:'كلمه السر',
	PORT:'ميناء',
	SECTYPE:'نوع الأمن',
	ACTION:'عمل',
SERIAL_NO:'الرقم التسلسلي',
AD_EMAILREQUIRED:'اسم المستخدم مطلوب',
SUB:'إرسال',
UPDATE:'تحديث',


},
LOCATE:{
	TITLE: 'Location',
	SERIAL_NO: 'S.No',
	ADD: 'Add',
	CITY: 'City',
	ACT: 'Action',
	LOCAL: 'Location',
	STATE: 'State',
	COUNTRY: 'Country',
	ADD_LOCATE: 'Add Location',
	Edit_LOCATE: 'Edit Location',
	LOCATEID:'Location Id',
},
KNBS:{
	TITLE:'Knowledge Base',
	SOL:'المحلول',
	IMG:'صورة',
	VID:'فيديو',
	ACTION:'عمل',
	PRDSC:'وصف المنتج',
	SUBPRO:'فئة المنتج الفرعي',
	PRO:'Product-Category'
	
			},
ORG_STR:{
	BULK:'تحميل مجمع',
	SAMPLE:'نموذج القالب',
	SELECT:' اختر الملف',
	UPLOAD:'رفع',
	CANCEL:'إلغاء',
	BULKORG:'تحميل جماعي للمؤسسة',
	DEL:'حذف',
},
SMS:{
	ACTION:'عمل',
	SERIAL_NO:'الرقم التسلسلي',
	GATEWAY:'اسم بوابة الطريق',
	ADDGATE:'إضافة بوابة',
	ADD_SMS:'إنشاء رسائل SMS',
	URL:'Url',
URLR:'عنوان Url مطلوب',
SUB:'إرسال',
UPDATE:'تحديث',
URLRP:'عنوان url يبدأ HTTP: // ',
GATE:'بوابة',
GATER:'بوابة مطلوب',
EDIT_SMS:'تحديث إعدادات الرسائل القصير',
},
CUSTOMER:{
	TITLE:'ادارة الزبائن',
	BULK:'تحميل مجمع',
	SAMPLE:'نموذج القالب',
	SELECT:' اختر الملف',
	UPLOAD:'رفع',
	CANCEL:'إلغاء',
BULKCUS:'تحميل جماعي للعملاء',
ACTION:'عمل',
	SERIAL_NO:'الرقم التسلسلي',
	CUSID:'هوية الزبون',
CONNAME:'اسم جهة الاتصال',
CONNUM:'رقم الاتصال',
UPDATE:'تحديث',
CLOSE:'قريب',
VIEW:'عرض معلومات العقد',
DURATION: 'مدة العقد',
			CUSCODE: 'كود العميل',
			PLONO: 'رقم الباب / القطعة',
			STR: 'الشارع / المنطقة',
			LAND: 'معلم معروف',
			POSCODE: 'الكود البريدى',
			COUNTRY: 'بلد',
			STATE: 'حالة',
			CITY: 'مدينة',
			BULKDON: 'تنزيل مجمع',
			NAME: 'اسم',
			EMAIL: 'البريد الإلكتروني',
			MONUM: 'نموذج رقم',
			SELNO: 'الرقم التسلسلي',
			CONNUMBER: 'رقم الاتصال',
			ALTCONNUMBER: 'عدد البديل',
			CONTRACT: 'عقد',
			PRODUCT: 'المنتج',
			SUBPRODUCT: 'منتج ثانوي',
			COND:'تفاصيل العقد',
			ID:'ID',
			CONTYPE:'نوع العقد',
			PROC:'فئة المنتج',
			SUBC:'فئة المنتج الفرعي',
			END:'تاريخ الانتهاء',
			EDITC:'تحرير تفاصيل العميل',
			VIEWC:'عرض تفاصيل العميل',
			CONL:'عنوان العميل',
			EDITCO:'تحرير تفاصيل العقد',
			VIEWCO:'عرض تفاصيل العقد',
			},


USER: {   
	  TITLE:'إدارةالمستخدم',          
 COMPANY_INFO:'معلومات الشركة',           
FULLNAME:'الاسم الكامل',
EMAIL:'البريد الإلكتروني',
CONNUMBER:'رقم الاتصال ',
CONALTNUMBER:'رقم الاتصال البديل',
NAME:' اسم المستخدم',
SERIAL_NO:'الرقم التسلسلي',
EMPCODE:'رمز الموظف',
USERNAME:'اسم',
ROLE:'وظيفة',   
ADDRESS:'عنوان', 
PLONO:'رقم الباب / القطعة',
STR:'الشارع / المنطقة',
LAND:'معلم معروف',           
CLOSE:'قريب',
COUNTRY:'بلد',
STATE:'حالة',
CITY:'مدينة',
POSCODE:'الكود البريدى', 
ACTION:'عمل',
LOCATION:'موقعك',
NODE:'العقدة',
REQ:'مطلوب',
VALID:'الرجاء إدخال',
DIGI:'يجب أن يكون 10 أرقام',
MUST:'يجب أن يكون في 6 أرقام',        
NEXT_STEP:'الخطوة التالية',
PREVIOUS:'السابق',
SUB:'إرسال',  
WORKP: 'الملف الشخصي للعمل',
BULKUP:'تحميل مجمع',
ADD:'إضافة مستخدم',
ADDO:'أضف',
USER:'المستعمل',
EMPID:'هوية الموظف'  ,  
TECH:'فني',
TECHI:'صورة فني',
VPL:'عرض قائمة المنتجات',
EDIT :'تعديل',
UPLOAD:'رفع',
CANCEL:'إلغاء',
SAMPLE:'عينة',
CHCL:'انقر هنا لتغيير الموقع',
CP:'إنشاء منتج ',
PRODUCT: 'المنتج',
			SUBPRODUCT: 'منتج ثانوي',
			SKILL: 'مستوى المهارة',
			WORK: 'نوع العمل',
			PD:'تفاصيل المنتج',
	CONNAME:'اسم جهة الاتصال',


},
NEWTCKT:{
	TITLE:'New Ticket',
	TCKID:'Ticket Id',
	TCH_ID:'Technician Id',
	TCH_NAME:'Technician Name',
	TCH_DET:'Technician details',
	SERIAL_NO: 'S.No',
	SK_LVL:'Skill Level',
	TA_PR:'Tasks Present',
	CUS_NAME:'Customer Name',
	CONNUMBER: 'Contact Number ',
	EMAIL: 'Email',
	CUR_LOC:'Current Location',
	LOC:'Location',
	TCKT_TYP:'Ticket Type',
	PRODUCT: 'Product',
	SUBPRODUCT: 'Subproduct',
	TCKTSTS: 'Ticket Status',
	ASIGN_TM:'Assigned Time',
	DATE:'Date',
	PRF_DATE:'Preferred Date',
	RAIS_TM:'Raised Time',
	ASSIGN:'Assign',
	REASSIGN:'Reassign',
	ASSIGNT:'Assignto',
	BULK:'Bulk upload',
	CALLCAT:'Call Category',
	SERVCAT:'Service Category',
	PROB:'Problem',
	WRKTYP: 'Work Type',
	UPLOAD:'Upload',
	ACTION: 'Action',
	ACTIONS:'Actions',
	CANCEL:'Cancel',
	TSK_CNT:'Task Count',
	REVENUEREPORT:'Revenue Report',
},
ONGO:{
	REQUEST_SPARE: ' Requested Spare(s)',
	TITLE:'On Going Tickets',
	SERIAL_NO: 'S.No',
	TCKID: 'Ticket Id',
	CUS_NAME: 'Customer Name',
	TECH_ID: 'Technician id',
	VISIT: 'Next Visit',
	ACTION: 'Plan of Action',
	REASON: 'Reason',
	START_TIME: 'Start Time',
	ESCALATE: 'Escalated Technician Id',
	PRE_TECH: 'Previous Technician Id',
	PRODUCT_CATEGORY: 'Product Category',
	SUB_CATEGORY: 'Sub Category',
	ACT: 'Action',
	SPARE_REQUEST: 'Spare Requested',
	LEAD: 'Lead Time',
	STATUS: 'Status',
},

COMTICK:{
	TITLE: 'Completed Tickets',
	SERIAL_NO: 'S.No',
	TCKID: 'Ticket Id',
	TECH_ID: 'Technician id',
	PRODUCT_CATEGORY: 'Product Category',
	SUB_CATEGORY: 'Sub Category',
	COM_TIME: 'Completed Time',
	ACT: 'Action',
	CLOSE_TIME: 'Closed Time',
	CUST_FEED: 'Customer Feedback',
	CUST_RATE: 'Customer Rating',
	DOWNLOAD: 'Download',
},
LEAD:{
	TITLE:'LEADERBOARD',
	RANK:'Rank',
	TCH_ID:'Technician Id',
	TCH_NAME:'Technician Name',
	SCORE:'Score',
			LEVEL:'Level'
},
SPARE:{
	TITLE:'Spare Request',
	NEW:'New Spares',
	APPROVED:'Approved Spares',
	REJECT:'Rejected Spares',
	TCTID:'Ticket ID',
	TECHID:'Technician ID',
	SPAREREQ:'Spare Required',
	CONTRACT:'Contract Type',
	AMT:'Amount',
	CUSTAPP:'Cutomer Approval',
	ACTION:'Action'
},
MANAGECONT:{
	TITLE:'Manage Contract',
	TCTID:'Ticket ID',
	CUSID:'Customer ID',
	PROCAT:'Product Category',
	PROMODEL:'Product Model No',
	SERIALNO:'Serial No',
	CONTYPE:'Contract Type',
	MODE:'Mode of Payment',
	CONAMT:'Contract Amount',
	ACTION:'Action',

	},
	TRAININGSCORE:{
		TITLE:'Training Score',
		TYPE:'Training Type',
		ASSESSMENT:'Assessment',
		STATUS:'Status',
		DATE:'Date',
		TECH:'Technician',
EMPID:'Employee ID',
TECHN:'Technician Name',
PRO:'Product',
SUBPRO:'Subproduct',
SCORE:'Score',
SERIAL_NO:'S.No',
	},
REIM:{
	TITLE:'Reimbursement',
	NEWC:'New Claims',
	TECHID:'Technician ID',
	TECHN:'Technician Name',
	START:'Start Date',
	END:'End Date',
	CLAIMAMT:'Claim Amount',
	VIEW:'View Form',
	ACT:'Action',
	APPROVED:'Approved Claims',
	REJECT:'Rejected Claims'

},
TRANSFERSPARE:{
	TITLE:'Spare Transfer Request',
	SPARETRANSFER:'Spare Transfer Request',
	APPROVED:'Approved Spare',
	REJECT:'Rejected Spare',
	FROMT:'From Technician',
	TOT:'To Technician',
	SPARE:'Spare Required',
	ACTION:'Action'

},
IMPRESTSPARE:{
	TITLE:'Imprest Spare Request',
	NEWSP:'New Spare',
	APPROVED:'Approved Spare',
	TECHID:'Technician Id',
	TECHN:'Technician Name',
	SPARE:'Spare Required',
	ACTION:'Action',
	STATUS:'Status'
},
BUTTON:{
	SUB:'إرسال',
	NEXT:'التالى',
	UP:'رفع',
	DOWN:'تحميل',
	PRE:'السابق',
},
PERFOM:{
	TITLE:'مصفوفة الأداء',
	TECHL:'مستوى فني',
	LEV1:'المستوى 1',
	LEV2:'المستوي 2',
	LEV3:'مستوى 3',
	LEV4:'مستوى 4',
	TERMS:'شروط',
	TARGET:'استهداف',
	REWARD:'مكافأة',
	AVGCALL:'متوسط ​​المكالمات / اليوم',
	FIRST:'معدل الإصلاح لأول مرة / شهر (٪)',
	SERVICE:'ايرادات عقد الخدمة / الشهر	',
	CUSTOMER:'تقييم العملاء',
	CONTRIBUTION:'المساهمة في KB / الشهر',
	TRAINING:'تدريب وشهادة / شهر',
	SLAADHERE:'الالتزام باتفاقية مستوى الخدمة / شهر (٪)',
	CUSTOMERFEED:'ملاحظات العملاء (٪)',
	MTTR:'هدف MTTR / شهر (٪)',
	FIELDS:'الحقول مطلوبة',
},
	}
};